import React, { createContext, useContext } from 'react'
import { useVocab } from '@sainsburys-tech/bolt-vocab-provider'
import featureBrandConfigs from './config/featureBrandConfigs'

const BrandConfigContext = createContext()

const BrandContextProvider = ({ children, brand }) => {
  return (
    <BrandConfigContext.Provider value={featureBrandConfigs[brand.toLocaleLowerCase()] || featureBrandConfigs.argos}>
      {children}
    </BrandConfigContext.Provider>
  )
}

// For Functional Components
const useBrandConfigContext = () => {
  const context = useContext(BrandConfigContext)
  if (context === undefined) {
    throw new Error('useBrandConfigContext must be used within a BrandContextProvider')
  }
  return context
}

// For Class Components
const BrandContextConsumer = ({ vocab, children }) => {
  return (
    <BrandConfigContext.Consumer>
      {brandConfig => {
        if (brandConfig === undefined) {
          throw new Error('BrandContextConsumer must be used within a VocabProvider')
        }
        return React.Children.map(children, child =>
          React.cloneElement(child, {
            ...brandConfig,
            ...vocab
          })
        )
      }}
    </BrandConfigContext.Consumer>
  )
}

const BrandAndVocabContextConsumer = ({ children }) => {
  const vocab = useVocab()
  return (
    <BrandConfigContext.Consumer>
      {brandConfig => {
        if (brandConfig === undefined) {
          throw new Error('BrandContextConsumer must be used within a VocabProvider')
        }
        return React.Children.map(children, child =>
          React.cloneElement(child, {
            ...vocab,
            ...brandConfig
          })
        )
      }}
    </BrandConfigContext.Consumer>
  )
}

export {
  BrandConfigContext,
  BrandContextProvider,
  useBrandConfigContext,
  BrandContextConsumer,
  BrandAndVocabContextConsumer
}
